<template>
    <ModalComponent
        name="cargarPrecios"
        title="Cargar precios de otro evento / sesión"
        v-on:close="() => close(false)">
        <div class="col-12" v-if="!loading">
            <div class="form-group">
                <label for="provincias">Cargar precios de evento anterior</label>
                <select class="form-control" id="evento" v-model="old_event">
                    <template v-for="evento in events">
                        <option :key="evento.id" :value="evento.id">{{ evento.name }}</option>
                    </template>
                </select>
            </div>
        </div>
        <div class="col-12" v-if="sesiones && !loading">
            <div class="form-group">
                <label for="sesiones">Seleccionar sesion</label>
                <select class="form-control" id="sesiones" v-model="old_sesion">
                    <template v-for="sesion in sesiones">
                        <option :key="sesion.id" :value="sesion.id">{{ sesion.fecha }}</option>
                    </template>
                </select>
            </div>
        </div>
        <div class="col-12" v-if="old_sesion && !loading">
            <div class="custom-control custom-checkbox mb-3">
                <input class="custom-control-input" type="checkbox" id="vincular_precios" v-model="vincular_precios">
                <label class="custom-control-label" for="vincular_precios">
                    Vincular los precios a las regiones y las plazas
                </label>
            </div>
            <div class="text-right">
                <Button @click.prevent="copiarTickets">CONTINUAR</Button>
            </div>
        </div>
        <div class="col-12" v-if="loading" style="padding: 100px">
            <LoaderComponent></LoaderComponent>
        </div>
    </ModalComponent>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";

export default {
    props: ['sesion', 'evento_id'],
    data() {
        return {
            values: {},
            events: [],
            loading: false,
            old_event: null,
            old_sesion: null,
            sesiones: null,
            vincular_precios: null
        }
    },
    created() {
        this.getEvents();
    },
    watch: {
        old_event() {
            this.getEvento(this.old_event);
        }
    },
    methods: {
        close(creado) {
            this.$emit('close', 'cargarPrecios', creado);
        },
        getEvents : function() {
            this.loading = true;
            const data = {
                filters: {
                    per_page: 100,
                    page: 1,
                    search: '',
                    to_select: true
                }
            };
            this.$store.dispatch(this.config.getVuexAlias('back.events.index'), data).then(res => {
                this.events = res.data.filter(event => event.id != this.evento_id);
            }).finally(() => this.loading = false);
        },
        getEvento(evento_id) {
            this.loading = true;

            const data = {
                evento_id: evento_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.show'), data).then(res => {
                this.sesiones = res.data.data.sesiones;
            }).finally(() => this.loading = false);
        },
        copiarTickets() {
            this.loading = true;

            const data = {
                evento_id: this.evento_id,
                sesion_id: this.sesion.id,
                old_event: this.old_event,
                old_sesion: this.old_sesion,
                vincular: this.vincular_precios
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.tickets.copiar'), data).then(res => {
                this.$toast.success(res.data.message);
                this.close(true);
            }).finally(() => this.loading = false);
        }
    },
    components: {
        ModalComponent
    }
}
</script>

<style>
    .formulate-input {
        margin: 0 0 1rem;
    }

    .formulate-input .formulate-input-errors {
        background-color: #dc3545;
        color: #ffffff;
        font-size: 11px;
        padding: 5px 10px;
    }
</style>